import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", this.handleAnchorClick);
    });
  }

  disconnect() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.removeEventListener("click", this.handleAnchorClick);
    });
  }

  handleAnchorClick = (e) => {
    const id = e.currentTarget.getAttribute("href");
    const target = document.querySelector(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
}
